import { render, staticRenderFns } from "./FrsCurrentFieldBorderLayer.vue?vue&type=template&id=83de5aaa&scoped=true&lang=html&"
import script from "./FrsCurrentFieldBorderLayer.vue?vue&type=script&lang=js&"
export * from "./FrsCurrentFieldBorderLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83de5aaa",
  null
  
)

export default component.exports